<template>
  <form @submit.prevent="handleSubmit">
    <div class="form-group">
      <div
        class="alert text-left formatted-text"
        :class="{
          'alert-danger': message.error,
          'alert-success': !message.error,
        }"
        role="alert"
        v-show="message.display"
      >
        {{ this.message.content }}
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <fieldset>
          <legend class="view-legend">Version française</legend>
          <div class="form-group">
            <label for="title">Titre</label>
            <input
              v-model="faq.title"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': submitted && !faq.title }"
              id="title"
              placeholder="Titre"
              name="title"
            />
          </div>

          <div class="form-group">
            <label for="content">Contenu</label>
            <wysiwyg v-model="faq.content" />
          </div>
        </fieldset>
      </div>
      <div class="col-md-6">
        <fieldset>
          <legend class="view-legend">Version anglaise</legend>
          <div class="form-group">
            <label for="title_en">Titre</label>
            <input
              v-model="faq.title_en"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': submitted && !faq.title_en }"
              id="title_en"
              placeholder="Title"
              name="title_en"
            />
          </div>

          <div class="form-group">
            <label for="content_en">Contenu</label>
            <wysiwyg v-model="faq.content_en" />
          </div>
        </fieldset>
      </div>
    </div>
    <div class="form-group">
      <!-- <label class="col-md-2"></label> -->
      <div class="col-md-8">
        <button type="submit" class="btn btn-primary">Enrégister</button>
        <router-link
          class="btn btn-dark action-btn-cancel"
          :to="{ name: 'faqs' }"
        >
          Retourner
        </router-link>
      </div>
    </div>
  </form>
</template>

<script>
import Vue from "vue";

import wysiwyg from "vue-wysiwyg";
Vue.use(wysiwyg, { locale: "fr" });

import { UPDATE_FAQ } from "@/store/actions.type";
import { SET_LOADING } from "@/store/mutations.type";
import { SUCCESS_MESSAGE } from "@/helpers/messages";

export default {
  name: "FaqForm",
  data() {
    return {
      faq: {
        title: "",
        title_en: "",
        content: "",
        content_en: "",
      },
      submitted: false,
      message: {
        error: false,
        display: false,
        content: "",
      },
    };
  },
  mounted(){
    this.faq = this.$store.state.faq.faq;
  },
  methods: {
    handleSubmit() {
      // affichage réinitialisé
      this.message.display = false;

      this.submitted = true;

      const { title, title_en, content, content_en } = this.faq;
      if (!title || !title_en || !content || !content_en) {
        return;
      }

      this.$store.commit(SET_LOADING, true);

      this.$store
        .dispatch(UPDATE_FAQ, this.faq)
        .then(() => {
          this.message.content = SUCCESS_MESSAGE;
          this.message.display = true;

          //On réinitialise l'état
          this.faq = {
            title: "",
            title_en: "",
            content: "",
            content_en: "",
          };

          this.submitted = false;
        })
        .catch((error) => {
          this.message.content = `${error} \n ${JSON.stringify(error.errors)}`;
          this.message.display = true;
          this.message.error = true;
          this.submitted = false;
        })
        .finally(() => {
          this.$store.commit(SET_LOADING, false);
        });
    },
  },
};
</script>

<style>
@import "~vue-wysiwyg/dist/vueWysiwyg.css";
</style>